(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('lead-hospitalization', {
            parent: 'entity',
            url: '/lead-hospitalization?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'sigmasfApp.leadHospitalization.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/lead-hospitalization/lead-hospitalizations.html',
                    controller: 'LeadHospitalizationController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('leadHospitalization');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('lead-hospitalization-detail', {
            parent: 'entity',
            url: '/lead-hospitalization/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'sigmasfApp.leadHospitalization.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/lead-hospitalization/lead-hospitalization-detail.html',
                    controller: 'LeadHospitalizationDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('leadHospitalization');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'LeadHospitalization', function($stateParams, LeadHospitalization) {
                    return LeadHospitalization.get({id : $stateParams.id});
                }]
            }
        })
        .state('lead-hospitalization.new', {
            parent: 'lead-hospitalization',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/lead-hospitalization/lead-hospitalization-dialog.html',
                    controller: 'LeadHospitalizationDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                isClosedHospitalization: null,
                                hadSurgery: null,
                                surgeryType: null,
                                sectorOther: null,
                                diagnosisDate: null,
                                possibleDischargeDate: null,
                                isFollowingHospitalization: null,
                                comments: null,
                                addDiseaseOther: null,
                                hospitalizationDate: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('lead-hospitalization', null, { reload: true });
                }, function() {
                    $state.go('lead-hospitalization');
                });
            }]
        })
        .state('lead-hospitalization.edit', {
            parent: 'lead-hospitalization',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/lead-hospitalization/lead-hospitalization-dialog.html',
                    controller: 'LeadHospitalizationDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['LeadHospitalization', function(LeadHospitalization) {
                            return LeadHospitalization.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('lead-hospitalization', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('lead-hospitalization.delete', {
            parent: 'lead-hospitalization',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/lead-hospitalization/lead-hospitalization-delete-dialog.html',
                    controller: 'LeadHospitalizationDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['LeadHospitalization', function(LeadHospitalization) {
                            return LeadHospitalization.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('lead-hospitalization', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
